import { ReactElement, ReactNode } from 'react'
import { isNull } from 'lodash-es'
import { InsertDriveFile } from '@mui/icons-material'
import { Box, CircularProgress } from '@mui/material'
import { ErrorState, Info } from '@ui/feedback'

interface Props {
  error: string | null
  documentSelected: boolean
  isLoading: boolean
  /** Shown instead of the default hint while no document is loaded */
  emptyState?: ReactNode
}

const ViewerPlaceholders = ({
  error,
  documentSelected,
  isLoading,
  emptyState,
}: Props): ReactElement | null => {
  if (!isNull(error)) {
    return (
      <Box
        width="100%"
        height="calc(100vh - 64px)"
        display="flex"
        justifyContent="center"
        alignItems="center"
        flex={1}
      >
        <ErrorState error={`Fehler beim Laden des Dokuments: ${error}`} center={false} />
      </Box>
    )
  }

  if (isLoading) {
    return (
      <Box
        width="100%"
        height="calc(100vh - 64px)"
        display="flex"
        justifyContent="center"
        alignItems="center"
        flex={1}
      >
        <CircularProgress size={28} />
      </Box>
    )
  }

  if (!documentSelected) {
    return (
      <Box
        display="flex"
        flex={1}
        justifyContent="center"
        alignItems="center"
        sx={{ height: 'calc(100vh - 64px)' }}
      >
        {emptyState ?? <Info icon={<InsertDriveFile />}>Noch kein Dokument geladen</Info>}
      </Box>
    )
  }

  return null
}

export default ViewerPlaceholders
